import React, { memo } from "react";
import useStyles from "./styles";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";


function WaitLayout({ hasBackground = false }) {
  const classes = useStyles({ hasBackground });
  return (
    <div className={classes.root}>
      {/* <CircularProgress color="secondary" /> */}
    </div>
  );
}

export default memo(WaitLayout);
